export default __webpack_public_path__ + "static/media/IMG_1968.d44b0dcc.JPG";